import { saveState } from '../../localStorage';
import { eivngCore } from '../../EivngCore';
import { showConfirmDialog } from '../confirmDialog/actions';
import { countOffeneTeilnahmen } from '../punkteMeldung/commonUtils';


export const appScreens = {
  startPage : "startPage",
  veranstalterPage : 'veranstalterPage',
  veranstaltungPage : 'veranstaltungPage',
  druckansichtPage : 'druckansichtPage'
};

// Anwesenheitsliste (vor dem Melden, zum Unterschreiben) oder Meldeprotokoll (nach dem
// Melden, zur Ablage). Steht hier und nicht im lokalen State der Druckansicht, weil es die
// Einstiegsentscheidung von der Veranstaltungsseite ist - umschalten kann man dort trotzdem.
export const druckVarianten = {
  anwesenheitsliste : 'anwesenheitsliste',
  meldeprotokoll : 'meldeprotokoll'
};

export const SET_SCREEN = 'SET_SCREEN'
export const SET_SCREEN_VERANSTALTUNG = 'SET_SCREEN_VERANSTALTUNG'
export const SET_SCREEN_DRUCKANSICHT = 'SET_SCREEN_DRUCKANSICHT'
export const SET_SAVE_STATE_TO_LOCAL_STORAGE = 'SET_SAVE_STATE_TO_LOCAL_STORAGE';
export const DISPLAY_DIALOG_QRCODE_LINK_TO_APP = 'DISPLAY_DIALOG_QRCODE_LINK_TO_APP'
export const SET_DISPLAY_MODE = 'SET_DISPLAY_MODE'


// Action creator
export const setScreen = (screen) => {
	return { type: SET_SCREEN, payload : screen }
}
export const setScreenVeranstaltung = (vnr) => {
	return { type: SET_SCREEN_VERANSTALTUNG, payload : vnr }
}
export const setScreenDruckansicht = (variante) => {
	return { type: SET_SCREEN_DRUCKANSICHT, payload : variante }
}
export const setSaveStateToLocalStorage = ( flagEnabled ) => {
	return { type: SET_SAVE_STATE_TO_LOCAL_STORAGE, payload : flagEnabled }
}

/**
 * Schaltet die lokale Speicherung ein - **erst schreiben, dann das Flag setzen**.
 *
 * Das Flag allein bewirkt nichts: geschrieben wird, wenn store.subscribe das naechste Mal durch
 * throttle(..., 1000) kommt (index.js). lodash feuert zwar auf der steigenden Flanke, aber nach
 * einer Aktion in der letzten Sekunde - beim Erfassen der Normalfall - erst verzoegert. In der
 * umgekehrten Reihenfolge stuende also "Auf diesem Geraet gespeichert" da, waehrend noch nichts
 * gespeichert ist; wer in dieser Sekunde neu laedt, verliert alles und hat eine Zusage gelesen.
 *
 * So braucht es auch kein Zurueckrollen: schlaegt das Schreiben fehl, wurde nie etwas behauptet.
 * Der geschriebene Zustand traegt das Flag bereits, ein Reload unmittelbar danach findet den
 * Modus eingeschaltet vor.
 *
 * Liefert true/false, damit der Aufrufer einen blockierten Speicher erklaeren kann.
 */
export const aktiviereLokalesSpeichern = () => (dispatch, getState) => {
	const state = getState();
	const zustandZumSpeichern = {
		...state,
		appNavigation: { ...state.appNavigation, saveStateToLocalStorage: true }
	};
	if(!saveState(zustandZumSpeichern)) return false;
	dispatch(setSaveStateToLocalStorage(true));
	return true;
}
export const displayDialogQrcodeLinkToApp = ( flagDisplay ) => {
	return { type: DISPLAY_DIALOG_QRCODE_LINK_TO_APP, payload : flagDisplay }
}
export const setDisplayMode = ( modus ) => {
	return { type: SET_DISPLAY_MODE, payload : modus }
}
const zaehle = (anzahl, einzahl, mehrzahl) => anzahl === 0 ? null : `${anzahl} ${anzahl === 1 ? einzahl : mehrzahl}`;

/**
 * Was beim Ausschalten von diesem Geraet verschwindet - null, wenn es nichts zu verlieren gibt.
 *
 * Bewusst mit Zahlen statt "Ihre Daten": am Einlasstisch entscheidet, ob dort "3 erfasste und
 * noch nicht gemeldete Teilnahmen" steht oder nichts dergleichen.
 */
export const beschreibeGespeichertes = (state) => {
	const teile = [
		zaehle(Object.keys(state.veranstaltungen || {}).length, "Veranstaltung", "Veranstaltungen"),
		zaehle(countOffeneTeilnahmen(state), "erfasste und noch nicht gemeldete Teilnahme",
			"erfasste und noch nicht gemeldete Teilnahmen"),
		zaehle(Object.values(state.punkteMeldung.beschriftungen || {})
			.reduce((summe, je) => summe + Object.keys(je || {}).length, 0),
			"hinterlegter Name", "hinterlegte Namen")
	].filter(teil => teil);
	if(teile.length === 0) return null;
	if(teile.length === 1) return teile[0];
	return `${teile.slice(0, -1).join(", ")} und ${teile[teile.length - 1]}`;
}

/**
 * Schaltet die lokale Speicherung aus - und fragt vorher, wenn es etwas zu verlieren gibt.
 *
 * `resetSettings()` ist localStorage.clear() plus Reload: ein Klick, und alle Veranstaltungen,
 * alle erfassten Teilnahmen und alle Namen sind weg, auch die noch nicht gemeldeten. Das ist die
 * teuerste Aktion der App und hatte als einzige keine Rueckfrage. Steht nichts drin, wird auch
 * nicht gefragt - dann ist es nur ein Schalter.
 */
export const deaktiviereLokalesSpeichern = () => (dispatch, getState) => {
	// **Erst das Flag, dann loeschen.** localStorage.clear() allein reicht nicht: der Reload ist
	// nicht sofort, und jede Store-Aenderung bis dahin - allein schon das Schliessen des
	// Bestaetigungsdialogs - laeuft durch den subscribe-Lauf in index.js und schreibt alles
	// wieder hinein, Flag inklusive. Danach laedt der Reload den "geloeschten" Zustand zurueck
	// und der Schalter steht wieder auf "an". Mit ausgeschaltetem Flag ueberspringt der Lauf das
	// Schreiben, weil er den Zustand frisch liest.
	//
	// Der Fehler war zeitabhaengig und deshalb heimtueckisch: throttle(..., 1000) feuert auf der
	// steigenden Flanke. Wer schnell klickt, faellt in ein verbrauchtes Fenster und sieht nichts;
	// wer den Dialog liest und dann bestaetigt - der Normalfall -, trifft die Flanke.
	const zuruecksetzen = () => {
		dispatch(setSaveStateToLocalStorage(false));
		eivngCore.resetSettings();
	};
	const verlust = beschreibeGespeichertes(getState());
	if(verlust === null){
		zuruecksetzen();
		return;
	}
	dispatch(showConfirmDialog(
		"Lokale Speicherung ausschalten",
		`Dabei wird alles von diesem Gerät entfernt: ${verlust}. Bereits gemeldete Punkte sind `
		+ `davon nicht betroffen – sie liegen im EIV.`,
		zuruecksetzen,
		"Ausschalten und löschen"));
}
